<template>
  <el-card>
    <el-form ref="searchForm" :model="searchForm" class="global-form" :inline="true">
      <el-form-item>
        <el-select v-model="searchForm.projectId" clearable placeholder="所属项目">
          <el-option v-for="item in projectList" :key="item.projectId" :label="item.projectName"
            :value="item.projectId"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-input v-model="searchForm.contractName" placeholder="合同名称" clearable></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" class="medium" @click="onSearch">查询</el-button>
      </el-form-item>
    </el-form>
    <div class="mb20">
      <el-button type="primary" icon="el-icon-plus" @click="$router.push('/yhcontract/add')">新增</el-button>
    </div>
    <el-table ref="table" class="global-table" stripe v-loading="loading" :data="tableData" max-height="550px">
      <el-table-column label="合同名称" prop="contractName" show-overflow-tooltip></el-table-column>
      <el-table-column label="所属项目" prop="projectName" show-overflow-tooltip></el-table-column>
      <el-table-column label="开始日期" prop="startDate" show-overflow-tooltip></el-table-column>
      <el-table-column label="结束日期" prop="endDate" show-overflow-tooltip></el-table-column>
      <el-table-column label="养护等级" prop="maintainLevelName" show-overflow-tooltip></el-table-column>
      <el-table-column label="合同总额（元）" prop="contractAmount" show-overflow-tooltip></el-table-column>
      <el-table-column label="操作" width="180px" fixed="right">
        <template v-slot="{ row }">
          <el-button type="text" @click="$router.push('/yhcontract/details?contractId=' + row.contractId)">查看</el-button>
          <el-button type="text" @click="$router.push('/yhcontract/edit?contractId=' + row.contractId)">编辑</el-button>
          <el-button type="text" @click="onDelete(row.contractId)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <global-pagination :total="total" :current-page.sync="page" :page-size.sync="size" @current-change="loadData"
      @size-change="loadData"></global-pagination>
  </el-card>
</template>

<script>
export default {
  name: "YhContract",
  data() {
    return {
      page: 1,
      size: 10,
      total: 0,
      loading: false,
      tableData: [],
      searchForm: {
        projectId: '',
        contractName: ''
      }
    }
  },
  computed: {
    projectList() {
      return this.$store.state.projectList
    }
  },
  watch: {},
  created() {
    this.loadData()
  },
  methods: {
    loadData() {
      this.loading = true
      this.$axios.get(this.$apis.operate.selectContractByPage, {
        page: this.page,
        size: this.size,
        ...this.searchForm,
      }).then((res) => {
        this.total = res.total || 0
        this.tableData = res.list || []
      }).finally(() => {
        this.loading = false
      })
    },
    onSearch() {
      this.page = 1
      this.loadData()
    },
    onDelete(contractId) {
      this.$confirm('确认删除吗, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post(this.$apis.operate.deleteContract, { contractId }).then(() => {
          this.$message.success('删除成功')
          this.onSearch()
        })
      })
    }
  }
}
</script>

<style scoped lang="scss"></style>
